import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// gtag.js (loaded in public/index.html) only fires its initial page_view on
// the first real browser page load — React Router changes the URL without a
// reload, so without this GA would only ever see one pageview per visit no
// matter how many in-app pages the user goes through.
declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (typeof window.gtag !== "function") return;
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [location]);

    return null;
};

export default AnalyticsTracker;
